import React from 'react';
import chroma from 'chroma-js';

import Graphic from '../Graphic';
import { useTheme } from '../../../hooks/index';

const Links = props => {
  const { primary } = useTheme();

  return (
    <Graphic
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 140 145"
      preserveAspectRatio="xMidYMid meet"
      fill="none"
      {...props}>
      <path
        fill="#F3F3F4"
        d="M70.994 145c28.166 0 51-1.567 51-3.5s-22.834-3.5-51-3.5c-28.167 0-51 1.567-51 3.5s22.833 3.5 51 3.5Z"
      />
      <path
        fill="#D9D9D9"
        d="M70.155 139.214c33.775 0 61.155-27.359 61.155-61.107S103.93 17 70.155 17C36.38 17 9 44.358 9 78.107c0 33.748 27.38 61.107 61.155 61.107Z"
      />
      <path
        fill="#D9D9D9"
        d="M108.743 125.641C98.103 134.601 84.36 140 69.356 140c-10.04 0-19.516-2.418-27.875-6.702-.642-.738-.981-1.507-.981-2.298 0-5.523 16.566-10 37-10 13.139 0 24.678 1.851 31.243 4.641Z"
      />
      <path
        fill={primary}
        fillOpacity=".75"
        d="M108.743 125.641C98.103 134.601 84.36 140 69.356 140c-10.04 0-19.516-2.418-27.875-6.702-.642-.738-.981-1.507-.981-2.298 0-5.523 16.566-10 37-10 13.139 0 24.678 1.851 31.243 4.641Z"
      />
      <path
        fill="#D9D9D9"
        d="M51.911 137.329a1.78 1.78 0 0 0 .2-.314l2.458-4.918 5.382 5.381a1.784 1.784 0 0 0 2.52-2.521l-5.38-5.381 4.917-2.459a1.785 1.785 0 0 0 .658-2.625 1.788 1.788 0 0 0-.793-.625l-17.825-7.13a1.784 1.784 0 0 0-1.925.392 1.78 1.78 0 0 0-.392 1.925l6.861 17.153c1.092.405 2.199.779 3.319 1.122Z"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        d="M51.911 137.329a1.78 1.78 0 0 0 .2-.314l2.458-4.918 5.382 5.381a1.784 1.784 0 0 0 2.52-2.521l-5.38-5.381 4.917-2.459a1.785 1.785 0 0 0 .658-2.625 1.788 1.788 0 0 0-.793-.625l-17.825-7.13a1.784 1.784 0 0 0-1.925.392 1.78 1.78 0 0 0-.392 1.925l6.861 17.153c1.092.405 2.199.779 3.319 1.122Z"
      />
      <path
        fill="#D9D9D9"
        d="M42.504 108.678c.14.192.241.412.296.644l.462 1.721a1.783 1.783 0 0 1-3.443.923l-.462-1.722a1.785 1.785 0 0 1 1.954-2.28 1.776 1.776 0 0 1 1.193.714Z"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        d="M42.504 108.678c.14.192.241.412.296.644l.462 1.721a1.783 1.783 0 0 1-3.443.923l-.462-1.722a1.785 1.785 0 0 1 1.954-2.28 1.776 1.776 0 0 1 1.193.714Z"
      />
      <path
        fill="#D9D9D9"
        d="M33.9 114.555a1.783 1.783 0 0 1 1.338-.192l1.722.462a1.782 1.782 0 0 1-.923 3.443l-1.722-.461a1.782 1.782 0 0 1-.415-3.252Z"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        d="M33.9 114.555a1.783 1.783 0 0 1 1.338-.192l1.722.462a1.782 1.782 0 0 1-.923 3.443l-1.722-.461a1.782 1.782 0 0 1-.415-3.252Z"
      />
      <path
        fill="#D9D9D9"
        d="M51.435 112.1c.006.464-.168.913-.487 1.25l-1.261 1.261a1.784 1.784 0 0 1-2.52-2.521l1.261-1.261a1.784 1.784 0 0 1 3.007 1.271Z"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        d="M51.435 112.1c.006.464-.168.913-.487 1.25l-1.261 1.261a1.784 1.784 0 0 1-2.52-2.521l1.261-1.261a1.784 1.784 0 0 1 3.007 1.271Z"
      />
      <path
        fill="#D9D9D9"
        d="m39.604 124.694-1.26 1.261h-.001a1.784 1.784 0 0 1-2.52-2.521l1.261-1.261a1.79 1.79 0 0 1 1.271-.559 1.784 1.784 0 0 1 1.249 3.08Z"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        d="m39.604 124.694-1.26 1.261h-.001a1.784 1.784 0 0 1-2.52-2.521l1.261-1.261a1.79 1.79 0 0 1 1.271-.559 1.784 1.784 0 0 1 1.249 3.08Z"
      />
      <path
        fill={primary}
        fillOpacity=".75"
        fillRule="evenodd"
        d="M110.816 124.85c.28-.248.556-.497.83-.748a.501.501 0 0 0-.316-.868.495.495 0 0 0-.36.131 63.969 63.969 0 0 1-1.646 1.457.51.51 0 0 0-.186.343.51.51 0 0 0 .118.373.495.495 0 0 0 .717.044c.283-.241.564-.485.843-.732Zm3.274-4.556a.497.497 0 0 0-.105.555.495.495 0 0 0 .672.251.492.492 0 0 0 .159-.119 61.377 61.377 0 0 0 4.316-5.089.499.499 0 0 0-.466-.798.503.503 0 0 0-.331.193 60.455 60.455 0 0 1-4.245 5.007Zm-9.417 9.343a.494.494 0 0 0 .21-.321.512.512 0 0 0-.079-.374.504.504 0 0 0-.515-.208.522.522 0 0 0-.18.077 60.106 60.106 0 0 1-3.7 2.336.503.503 0 0 0-.181.684.502.502 0 0 0 .684.181 62.11 62.11 0 0 0 3.761-2.375Zm-5.706 3.46a.501.501 0 0 0-.093-.915.5.5 0 0 0-.377.033c-18.15 9.695-39.99 9.416-57.776-.37a.502.502 0 0 0-.728.577.494.494 0 0 0 .246.299c18.08 9.947 40.277 10.232 58.729.376Zm24.138-25.146a.509.509 0 0 0 .048.554.488.488 0 0 0 .529.168.507.507 0 0 0 .299-.239c9.968-18.084 10.274-40.283.434-58.727a.498.498 0 0 0-.676-.207.498.498 0 0 0-.207.677c9.68 18.144 9.379 39.983-.427 57.774Zm-.639-59.687a.503.503 0 0 0 .684.18.5.5 0 0 0 .181-.683 60.79 60.79 0 0 0-2.374-3.762.5.5 0 1 0-.826.564 60.066 60.066 0 0 1 2.335 3.7Zm-89.689 79.612a.52.52 0 0 0 .37.097.504.504 0 0 0 .428-.564.496.496 0 0 0-.194-.33 60.521 60.521 0 0 1-5.007-4.244.504.504 0 0 0-.35-.117.504.504 0 0 0-.473.5.5.5 0 0 0 .136.344 61.529 61.529 0 0 0 5.09 4.314Zm-8.212-7.484a.497.497 0 0 0 .868-.317.5.5 0 0 0-.13-.359 69.981 69.981 0 0 1-.7-.776C2.46 93.87 4.83 55.582 29.905 33.397c25.076-22.185 63.367-19.87 85.551 5.16.231.263.46.526.686.79a.503.503 0 0 0 .716.069.503.503 0 0 0 .147-.547.485.485 0 0 0-.103-.171 55.36 55.36 0 0 0-.661-.763l-.036-.04-.035-.04a61.688 61.688 0 0 0-3.805-3.926.503.503 0 0 0-.064-.073 61.353 61.353 0 0 0-5.091-4.314.48.48 0 0 0-.128-.071 61.021 61.021 0 0 0-7.186-4.653.5.5 0 0 0-.147-.12c-18.08-9.95-40.278-10.234-58.728-.377a.5.5 0 0 0-.22.237c-.472.255-.94.516-1.407.785a.498.498 0 0 0-.318.063 61.565 61.565 0 0 0-3.761 2.375.498.498 0 0 0-.195.262 62.226 62.226 0 0 0-4.8 3.673.498.498 0 0 0-.306.12 63.74 63.74 0 0 0-1.672 1.48.5.5 0 0 0-.156.288 62.411 62.411 0 0 0-2.724 2.682.499.499 0 0 0-.29.15 61.682 61.682 0 0 0-4.316 5.09.499.499 0 0 0-.102.308 61.26 61.26 0 0 0-4.513 6.935.499.499 0 0 0-.234.215C6.04 67.068 5.733 89.266 15.574 107.71c.025.048.058.09.095.125.302.565.613 1.127.934 1.684.012.048.03.094.055.136a62.01 62.01 0 0 0 2.373 3.763.505.505 0 0 0 .076.087 62.091 62.091 0 0 0 4.71 6.056l.036.04.035.04.008.008c.221.25.443.497.67.742Z"
        clipRule="evenodd"
      />
      <path fill="#fff" d="M1 16h88v85H1V16Z" />
      <path stroke={primary} d="M1 16h88v85H1V16Z" />
      <path fill="#fff" d="M5.5 21.05h78v76h-78v-76Z" />
      <path
        fill="#D9D9D9"
        d="M19.5 21.05h-13a1 1 0 0 0-1 1v74a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-74a1 1 0 0 0-1-1ZM82.5 30.264h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.5 39.264h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.5 48.264h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.5 57.263h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.5 66.263h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.5 75.263h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM38.277 21.05H25.905a.905.905 0 0 0 0 1.81h12.372a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill={primary}
        d="M82.595 21.05h-5.281a.905.905 0 0 0 0 1.81h5.281a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#F3F3F4"
        d="M73.731 21.05H68.45a.905.905 0 0 0 0 1.81h5.281a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#D9D9D9"
        d="M32.959 24.669h-7.054a.905.905 0 0 0 0 1.81h7.054a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#fff"
        d="M89.114 113.213c7.403 0 13.404-5.996 13.404-13.393s-6.001-13.393-13.404-13.393S75.71 92.423 75.71 99.82s6.001 13.393 13.404 13.393Z"
      />
      <path
        fill="url(#a)"
        fillRule="evenodd"
        d="M89.114 113.217c7.403 0 13.404-5.997 13.404-13.394S96.517 86.43 89.114 86.43 75.71 92.426 75.71 99.823s6.001 13.394 13.404 13.394Zm1.676-18.416a1.676 1.676 0 0 0-3.351 0v3.348h-3.351a1.675 1.675 0 1 0 0 3.348h3.35v3.349a1.674 1.674 0 0 0 1.676 1.676 1.677 1.677 0 0 0 1.676-1.676v-3.349h3.35a1.674 1.674 0 1 0 0-3.348h-3.35v-3.348Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M120.5 22c0-9.389-7.611-17-17-17s-17 7.611-17 17 7.611 17 17 17 17-7.611 17-17Z"
      />
      <path
        fill={primary}
        fillOpacity=".25"
        d="M120.5 22c0-9.389-7.611-17-17-17s-17 7.611-17 17 7.611 17 17 17 17-7.611 17-17Z"
      />
      <path
        stroke={primary}
        d="M119.994 22c0-9.389-7.611-17-17-17s-17 7.611-17 17 7.611 17 17 17 17-7.611 17-17Z"
      />
      <path
        stroke={primary}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M104.822 20.172A3.99 3.99 0 0 0 101.994 19a3.998 3.998 0 0 0-2.829 1.172l-4 4a3.999 3.999 0 0 0 2.82 6.86 4.001 4.001 0 0 0 2.837-1.204l1.102-1.101m-.759-4.899A3.99 3.99 0 0 0 103.994 25a3.995 3.995 0 0 0 2.828-1.172l4-4a4.001 4.001 0 0 0-5.657-5.656l-1.099 1.1"
      />
      <path fill={primary} d="M119.994 29a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
      <path
        fill={primary}
        fillRule="evenodd"
        d="M110.451 27c1.275-4.057 5.065-7 9.543-7 4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.478 0-8.268-2.943-9.543-7Zm13.543 0a3.997 3.997 0 0 1-4 4 3.998 3.998 0 0 1-2.828-6.828A3.998 3.998 0 0 1 123.994 27Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M123.994 27a4 4 0 1 1-8.002-.002 4 4 0 0 1 8.002.002Zm-2 0a2 2 0 1 1-4.001 0 2 2 0 0 1 4.001 0Z"
        clipRule="evenodd"
      />
      <path
        fill={primary}
        fillOpacity=".25"
        fillRule="evenodd"
        d="M123.994 27a4 4 0 1 1-8.002-.002 4 4 0 0 1 8.002.002Zm-2 0a2 2 0 1 1-4.001 0 2 2 0 0 1 4.001 0Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M122.494 71.5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-12a1.998 1.998 0 0 1-2-2v-12Z"
      />
      <path
        stroke={primary}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M135 73.5v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 0 0 2-2v-12a2 2 0 0 0-2-2h-12a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2Z"
      />
      <defs>
        <linearGradient
          id="a"
          x1="89.114"
          x2="89.114"
          y1="86.43"
          y2="113.217"
          gradientUnits="userSpaceOnUse">
          <stop stopColor={chroma(primary).brighten(0.5 - 0)} />
          <stop offset="1" stopColor={primary} />
        </linearGradient>
      </defs>
    </Graphic>
  );
};
export default Links;
